import { PhilippinesFormInputs } from "./types";

export const buildPhilippinesPayoutPayload = (saved: PhilippinesFormInputs, otp?: string) => {
  const common = {
    quotationId: saved.quotationId,
    purpose: saved.purpose,
    purposeCode: saved.purpose,
    requestId: saved.reference,
    otp,
    currency: "PHP",
  };

  switch (saved.paymentMethod) {
    case "wallet":
      return {
        ...common,
        destinationType: saved.paymentMethod,
        walletType: saved.walletType,
        accountName: saved.accountName,
        accountNumber: saved.accountNumber,
        mobileNumber: saved.phoneNumber,
      };
    case "bank":
    case undefined:
      return {
        ...common,
        destinationType: saved.paymentMethod,
        accountName: saved.accountName,
        bankName: saved.bankName,
        swiftCode: saved.bankCode,
        accountNumber: saved.accountNumber,
        narration: saved.narration,
      };
    default: {
      const unhandled: never = saved.paymentMethod;
      return unhandled;
    }
  }
};
